<template>
  <div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" >
      <el-tab-pane label="标签等级" name="tag">
        <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onSearch">
          <SpFilterFormItem prop="tag_code">
            <el-input v-model="formData.tag_code" clearable placeholder="请输入标签ID" />
          </SpFilterFormItem>
          <SpFilterFormItem prop="err_level">
            <el-select
              v-model="formData.err_level"
              placeholder="请选择绑定状态"
              clearable
            >
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </SpFilterFormItem>
        </SpFilterForm>
        <SpFinder
          ref="finder"
          row-key="item_id"
          :split-count="10"
          :url="table_url"
          :setting="setting"
          fixed-row-action
          row-actions-fixed-align="right"
          :hooks="{
            beforeSearch: beforeSearch
          }"
        >
          <template slot="tableTop">
            <el-button type="primary" size="medium" @click="addChange">添加</el-button>
            <el-button type="primary" size="medium" @click="deleteItem">批量删除</el-button>
            <ImportDialog
              buttonName="批量导入"
              buttonSize="medium"
              fileName="批量导入"
              fileType="upload_ali_saf_tag_level"
            />
          </template>
      </SpFinder>
      </el-tab-pane>
      <el-tab-pane label="分数等级" name="score">
        <el-form label-width="150px">
          <el-form-item label="高风险用户识别分数">
            <el-input class="input-b" type='number' v-model="scoreForm.high" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="中风险用户识别分数">
            <el-input class="input-b" type='number' v-model="scoreForm.medium" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="低风险用户识别分数">
            <el-input class="input-b" type='number' v-model="scoreForm.small" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="saveScoreChange">保存</el-button>
      </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { useDialog } from '@shopex/finder'
import ImportDialog from '@/components/importDialog'
import { tableSetting } from './config'
import { List, createTag, deleteTag, setScoreSettingInfo, getScoreSettingInfo } from './api'

export default {
  components: {
    ImportDialog
  },
  data () {
    return {
      table_url: List,
      scoreForm: {
        high: '',
        medium: '',
        small: '',
      },
      formData: {
        tag_code: '',
        err_level: '',
      },
      levelList: [
        {label: '高风险', value: 'high'},
        {label: '中风险', value: 'medium'},
        {label: '低风险', value: 'small'},
      ],
      activeName: 'tag'
    }
  },
  computed: {
    setting() {
      return tableSetting(this)
    }
  },
  mounted() {
  },
  methods: {
    beforeSearch (params) {
      return {
        ...params,
        ...this.formData
      }
    },
    onSearch () {
      this.$refs.finder.refresh(true)
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    addChange () {
      useDialog(null, {
        title: `新增风险标签`,
        width: '50%',
        component: () => import('./comps/createForm.vue'),
        actions: [
          { label: '取消', key: 'close', size: 'default' },
          { label: '提交', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(async (arg) => {
        if(arg) {
          try {
            await createTag(arg)
            this.$message.success('新增成功')
            this.refresh()
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    handleClick (e) {
      console.log(e.name)
      this.activeName = e.name
      if (e.name === 'score') {
        this.getScoreDetail()
      } else {
        this.refresh()
      }
    },
    getScoreDetail() {
      getScoreSettingInfo().then(res => {
        this.scoreForm = res.data.data
      })
    },
    saveScoreChange() {
      setScoreSettingInfo(this.scoreForm).then(res => {
        this.$message({
          message: '设置成功',
          type: 'success'
        });
        this.getScoreDetail()
      })
    },
    deleteItem () {
      const selection = this.$refs.finder.$refs.finderTable.getSelection()
      if (selection.length === 0) return this.$message.error('请选择需要删除的数据')
      this.$confirm('请确认是否批量删除？', '提示').then(async () => {
        const ids = selection.map(v => v.id)
        await deleteTag({ ids })
        this.$message.success('删除成功')
        this.refresh()
      })
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .sp-finder .cell .sp-finder-actions__wrap {
  justify-content: center !important;
}
</style>
